import { useCallback, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from '../context/AuthContext';

export const useTrivia = (userSettings, setUserSettings) => {
    const { user } = useAuth();

    // Loading is now handled centrally by useDataSync

    const unlockTrivia = useCallback(async (triviaId) => {
        // 1. Update Local State immediately (Optimistic UI)
        let isNewLocal = false;
        setUserSettings(prev => {
            if (prev.unlockedTrivia?.includes(triviaId)) return prev;

            isNewLocal = true;
            const updated = {
                ...prev,
                unlockedTrivia: [...(prev.unlockedTrivia || []), triviaId]
            };
            localStorage.setItem('morse_settings_v1', JSON.stringify(updated));
            return updated;
        });

        // 2. Persist to DB if logged in and it was actually new
        if (user) {
            // We check the local state update to avoid spamming the DB, 
            // but we should also rely on the DB unique constraint for safety.
            // However, since setUserSettings is async state setting, we can't easily capture the *result* 
            // of the previous block here synchronously if we didn't use a variable.
            // But we already checked `includes` in the prev state block.
            // Better to just fire the insert. The valid constraint will handle duplicates.

            try {
                const { error } = await supabase
                    .from('user_trivia_unlocks')
                    .upsert({
                        user_id: user.id,
                        trivia_id: triviaId
                    }, { onConflict: 'user_id, trivia_id', ignoreDuplicates: true });

                // Ignore uniqueness error (code 23505)
                if (error && error.code !== '23505') {
                    console.error('Error syncing trivia unlock:', error);
                }
            } catch (err) {
                console.error('Error calling Supabase for trivia:', err);
            }
        }
    }, [user, setUserSettings]);

    return { unlockTrivia };
};
